import { render, staticRenderFns } from "./SystemDb.vue?vue&type=template&id=56d61dce&scoped=true&"
import script from "./SystemDb.vue?vue&type=script&lang=js&"
export * from "./SystemDb.vue?vue&type=script&lang=js&"
import style0 from "./SystemDb.vue?vue&type=style&index=0&id=56d61dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d61dce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d61dce')) {
      api.createRecord('56d61dce', component.options)
    } else {
      api.reload('56d61dce', component.options)
    }
    module.hot.accept("./SystemDb.vue?vue&type=template&id=56d61dce&scoped=true&", function () {
      api.rerender('56d61dce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/SystemDb.vue"
export default component.exports